import { render, staticRenderFns } from "./moviesinfo.vue?vue&type=template&id=66614a1f"
import script from "./moviesinfo.vue?vue&type=script&lang=js"
export * from "./moviesinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports